import React, { FC } from "react";

import { ExplorePage } from "./Pages/ExplorePage";
import { InsuranceFiltersContext } from "./Utils/Context/filtersContext";
import { InsuranceKeywordContext } from "./Utils/Context/keywordsContext";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { InsuranceListParams } from "../../Pages/InsuranceHome/InsuranceListParams.csharp";

export const InsuranceHome: FC<InsuranceListParams> = (props) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <InsuranceFiltersContext>
        <InsuranceKeywordContext>
          <ExplorePage {...props} />
        </InsuranceKeywordContext>
      </InsuranceFiltersContext>
    </InsuranceLabelsContext>
  );
};
